export const filterCounter = ({
  endDate,
  exportType,
  selectedCardNumbers,
  selectedCategories,
  selectedCurrencies,
  selectedEnvelopes,
  selectedPaymentTypes,
  selectedSearchQueryString,
  selectedVendors,
  startDate,
  type,
  viewedStatus
}) => {
  let filtersCount = 0;
  if (endDate !== null) {
    filtersCount += 1;
  }
  if (exportType !== null) {
    filtersCount += 1;
  }
  if (selectedSearchQueryString !== undefined && selectedSearchQueryString !== null) {
    filtersCount += 1;
  }
  if (startDate !== null) {
    filtersCount += 1;
  }
  if (type !== null) {
    filtersCount += 1;
  }
  if (viewedStatus !== "") {
    filtersCount += 1;
  }
  filtersCount += selectedCardNumbers.length;
  filtersCount += selectedCategories.length;
  filtersCount += selectedCurrencies.length;
  filtersCount += selectedEnvelopes.length;
  filtersCount += selectedPaymentTypes.length;
  filtersCount += selectedVendors.length;
  return filtersCount;
};



// WEBPACK FOOTER //
// ./src/js/utils/filter-counter.js